import { create } from 'zustand'

interface Tab {
  id: number
  dashboard_id: number
  name: string
  icon?: string
  position: number
  background_color: string
  font_family: string
  font_color: string
  layout_config?: any
}

interface Widget {
  id: number
  tab_id: number
  app_id: number
  app_name: string
  app_slug: string
  icon_url?: string
  position_x: number
  position_y: number
  width: number
  height: number
  config?: any
  allow_expand: boolean
  is_expanded: boolean
}

interface DashboardState {
  currentDashboardId: number | null
  currentTabId: number | null
  tabs: Tab[]
  widgets: Widget[]
  isEditMode: boolean
  expandedWidgetId: number | null
  
  setCurrentDashboard: (dashboardId: number) => void
  setCurrentTab: (tabId: number) => void
  setTabs: (tabs: Tab[]) => void
  setWidgets: (widgets: Widget[]) => void
  setEditMode: (isEditMode: boolean) => void
  setExpandedWidget: (widgetId: number | null) => void
  updateWidget: (widgetId: number, updates: Partial<Widget>) => void
  addWidget: (widget: Widget) => void
  removeWidget: (widgetId: number) => void
}

export const useDashboardStore = create<DashboardState>((set) => ({
  currentDashboardId: null,
  currentTabId: null,
  tabs: [],
  widgets: [],
  isEditMode: false,
  expandedWidgetId: null,
  
  setCurrentDashboard: (dashboardId) => set({ currentDashboardId: dashboardId }),
  setCurrentTab: (tabId) => set({ currentTabId: tabId }),
  setTabs: (tabs) => set({ tabs }),
  setWidgets: (widgets) => set({ widgets }),
  setEditMode: (isEditMode) => set({ isEditMode }),
  setExpandedWidget: (widgetId) => set({ expandedWidgetId: widgetId }),
  
  updateWidget: (widgetId, updates) =>
    set((state) => ({
      widgets: state.widgets.map((w) =>
        w.id === widgetId ? { ...w, ...updates } : w
      ),
    })),
  
  addWidget: (widget) =>
    set((state) => ({
      widgets: [...state.widgets, widget],
    })),
  
  removeWidget: (widgetId) =>
    set((state) => ({
      widgets: state.widgets.filter((w) => w.id !== widgetId),
    })),
}))




